import qs from 'qs';
import client from '@/api/base';

// Children
import preCoach from './pre-coach';

export default {
  async unselectCoach() {
    const response = await client.post('coaching/my-coach/unselect/');
    return response;
  },

  async getMyCoach() {
    const response = await client.get('coaching/my-coach/');
    return response;
  },

  async getMyCoachAvailableDay() {
    const response = await client.get('coaching/my-coach/schedule/days/');
    return response;
  },

  async getMyCoachAvailableTime(params) {
    const response = await client.get(`coaching/my-coach/schedule/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async getUpcomingMeetings() {
    const response = await client.get('coaching/my-coach/schedule/upcoming/');
    return response;
  },

  // async selectCoach(uuid) {
  //   const response = await client.post('events/my-coach/select/', { coach_uuid: uuid });
  //   return response;
  // },
  async selectCoach(uuid) {
    const response = await client.post('coaching/coaches/', { coach_uuid: uuid });
    return response;
  },

  async bookNextSession(data) {
    const response = await client.post('events/my-coach/schedule/next/', data);
    return response;
  },

  async rescheduleNextSession(data) {
    const response = await client.post('events/my-coach/schedule/reschedule/', data);
    return response;
  },

  ...preCoach,
};
